/**
 * Estrella ★ para añadir/quitar una propiedad de la watchlist (RFC-0020).
 * No renderiza nada para usuarios anónimos — el modelo es aditivo.
 */
import { useState } from 'react';
import { useAuth } from '../lib/auth';

export function WatchStar({ propertyId, size = 'sm' }: { propertyId: string; size?: 'sm' | 'lg' }) {
  const { user, isWatching, toggleWatch } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user) return null;

  const watching = isWatching(propertyId);

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await toggleWatch(propertyId);
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className={`watch-star watch-star-${size} ${watching ? 'watching' : ''}`}
      onClick={onClick}
      aria-pressed={watching}
      title={watching ? 'Quitar de mis observados' : 'Añadir a mis observados'}
    >
      {watching ? '★' : '☆'}
    </button>
  );
}
